export default __webpack_public_path__ + "static/media/riftbound_uncommon.42337fa4.svg";